// src/pages/quality/AnalyticsKKPage.js
import { useState } from 'react';
import { Link } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

const AnalyticsKKPage = () => {
  const { projects } = useAuth();
  const [selectedProjectId, setSelectedProjectId] = useState(() => {
    // Если у пользователя только один проект, выбираем его автоматически
    if (projects && projects.length === 1) {
      return projects[0].id;
    }
    // Иначе возвращаем null
    return null;
  });

  const handleProjectSelect = (projectId) => {
    setSelectedProjectId(projectId);
  };
  // Находим выбранный проект по ID
  const selectedProject = selectedProjectId ? projects.find(p => p.id === parseInt(selectedProjectId)) : null;
  return (
    <div className="main-content">
      <h1>Аналитика КК</h1>

      <div className="form-group">
        <label htmlFor="projectSelect">Выберите проект:</label>
        <select
          id="projectSelect"
          value={selectedProjectId || ''}
          onChange={(e) => handleProjectSelect(e.target.value)}
          className="project-select"
        >
          <option value="">-- Выберите проект --</option>
          {projects.map((project) => (
            <option key={project.id} value={project.id}>
              {project.name_text}
            </option>
          ))}
        </select>
      </div>
      
      {selectedProjectId && (
        <div className="analytics-options">
          <h2>Проект: {selectedProject.name_text}</h2>
          <div className="options-grid">
            <Link
              to={`/all-assessments/${selectedProjectId}`}
              className="btn btn-primary"
            >
              Аналитика оценок
            </Link>
            <Link
              to={`/assessment-charts/${selectedProjectId}`}
              className="btn btn-primary"
            >
              Графики
            </Link>
            <Link
              to={`/assessment-dynamics-charts/${selectedProjectId}`}
              className="btn btn-primary"
            >
              Динамические Графики
            </Link>
            <Link
              to={`/dynamic-assessments/${selectedProjectId}`}
              className="btn btn-primary"
            >
              Динамическая аналитика оценок
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default AnalyticsKKPage;
